import React, { useState } from "react";
import { Button, Container, Row, Col, Image, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";

function HomePage() {
  // Estado para controlar el modal del afiche
  const [showPosterModal, setShowPosterModal] = useState(false);

  const handleShowPosterModal = () => setShowPosterModal(true);
  const handleClosePosterModal = () => setShowPosterModal(false);

  return (
    <Container
      className="p-4 p-md-5 mb-4 bg-dark text-white rounded-5 shadow-lg border-0 mt-4"
      style={{ background: "linear-gradient(45deg, #212529 30%, #343a40 90%)" }}
    >
      <Row className="align-items-center">
        <Col lg={7} className="mb-4 mb-lg-0">
          <h1 className="display-4 display-md-3 fw-bold">Sudamericano 2027</h1>
          <h2 className="h3 text-primary mb-4">Radio Control - Calama CHILE</h2>
          <p className="lead fs-4">
            El evento más importante de automodelismo Radio Control para este
            2027 en Sudamérica. Inscripciones, información técnica y galería de
            fotos del 2019.
          </p>
          <hr className="my-4" />
          <Button
            variant="primary"
            size="lg"
            as={Link}
            to="/formulario"
            className="px-5 py-3 fw-bold shadow"
          >
            Formulario Inscripción
          </Button>
        </Col>
        <Col lg={5}>
          <Row className="g-3">
            <Col xs={6}>
              <Image
                src="/3.jpg"
                fluid
                className="rounded-4 shadow-sm border border-secondary w-100 hover-shadow"
                style={{ height: "200px", objectFit: "cover" }}
                alt="Auto RC de Carreras"
              />
            </Col>
            <Col xs={6}>
              <Image
                src="/8.jpg"
                fluid
                className="rounded-4 shadow-sm border border-secondary w-100 hover-shadow"
                style={{ height: "200px", objectFit: "cover" }}
                alt="Piloto manejando"
              />
            </Col>
            <Col xs={6}>
              <Image
                src="/11.jpg"
                fluid
                className="rounded-4 shadow-sm border border-secondary w-100 hover-shadow"
                style={{ height: "200px", objectFit: "cover" }}
                alt="Circuito de Radio Control"
              />
            </Col>
            <Col xs={6}>
              <Image
                src="/9.jpg"
                fluid
                className="rounded-4 shadow-sm border border-secondary w-100 hover-shadow"
                style={{ height: "200px", objectFit: "cover" }}
                alt="Taller de Automodelismo"
              />
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Sección del Afiche Oficial */}
      <Row className="mt-5 justify-content-center">
        <Col md={10} lg={8} className="text-center">
          <hr className="my-5 border-secondary" />
          <div className="p-2 bg-white rounded-4 shadow-lg d-inline-block border border-light">
            <Image
              src="/afiche.jpg"
              fluid
              className="rounded-3"
              alt="Afiche Oficial Sudamericano 2027"
              onClick={handleShowPosterModal} // Abre el modal al hacer clic
              style={{ cursor: "pointer" }} // Indica que es clicable
            />
          </div>
        </Col>
      </Row>

      {/* Modal para mostrar el afiche ampliado */}
      <Modal
        show={showPosterModal}
        onHide={handleClosePosterModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Afiche Oficial Sudamericano 2027</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Image
            src="/afiche.jpg"
            fluid
            alt="Afiche Oficial Sudamericano 2027"
          />
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default HomePage;
